import currencyItems from '@assets/data/currency.json';

export class CurrencyUtils {
  static getCurrencyByCode = (code: string) => {
    if (!code) return undefined;
    const item = currencyItems.find((x) => x.code.toLowerCase() == code.toLowerCase());
    return item;
  };

  static getSymbolByCode = (code: string) => {
    const item = this.getCurrencyByCode(code);
    const result = item?.symbol ?? '';
    return result;
  };
}
